<script>
export default {
    props: {
        active: {
            type: Boolean,
            required: true,
        },
        image: {
            type: String,
            default: null,
        },
    },
};
</script>

<template>
    <button
        :class="{ active }"
        class="flex items-center py-1"
        @click="$emit('click')"
    >
        <div
            class="radio-input mr-2"
            :style="image ? { backgroundImage: `url(${image})`, backgroundSize: 'cover' } : {}"
        >
            <div
                v-if="!image"
                class="radio-inner"
                :class="{ 'radio-inner--active': active }"
            />
        </div>
        <slot />
    </button>
</template>

<style scoped lang="scss">
button {
    @apply text-grey-darkest text-sm;

    &.active {
        @apply text-primary;
    }
}

.radio-input {
    @apply rounded-full border border-grey-dark flex items-center justify-center w-5 h-5 bg-center bg-no-repeat;
    transition: border-color 0.2s ease;

    .radio-inner {
        @apply rounded-full bg-transparent w-2.5 h-2.5;
        transition: background-color 0.2s ease;

        &--active {
            @apply bg-primary;
        }
    }
}

button.active .radio-input {
    @apply border-primary;
}
</style>
